import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Logo } from "../components/Logo";

export default function Login() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  // Single source of truth for navigation: once `user` is set to a staff
  // account by `login()`, this component returns <Navigate>, React Router
  // unmounts it, and we land on /admin. No useEffect, no imperative navigate.
  if (user === null) return <div className="py-32 text-center font-mono-label">CHARGEMENT…</div>;
  if (user && (user.role === "admin" || user.role === "editor")) {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    await login(email, password);
    setSubmitting(false);
    // The render-time guard above handles the redirect once setUser fires.
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-16 bg-[#FAF8F3]" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <Logo size="md" />
          <div className="font-mono-label text-[#4B4B48] mt-3">ESPACE RÉDACTION</div>
        </div>
        <form onSubmit={submit} className="bg-[#FAF8F3] border-2 border-[#1A1A18] p-8 space-y-6" data-testid="login-form">
          <div>
            <label className="font-mono-label text-[#4B4B48] block mb-1">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-transparent border-b-2 border-[#1A1A18] w-full py-2 outline-none focus:border-[#4A7A3D]"
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="font-mono-label text-[#4B4B48] block mb-1">Mot de passe</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-transparent border-b-2 border-[#1A1A18] w-full py-2 outline-none focus:border-[#4A7A3D]"
              data-testid="login-password"
            />
          </div>
          {error && <p className="text-red-700 font-mono-label" data-testid="login-error">{error}</p>}
          <button
            type="submit"
            disabled={submitting}
            className="bg-[#4A7A3D] text-[#FAF8F3] w-full py-3 font-mono-label hover:bg-[#3E6633] disabled:opacity-60"
            data-testid="login-submit"
          >
            {submitting ? "CONNEXION…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
